/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBrandOnboardingStatus} from '../api'

 export const useQueryGetBrandOnboardingStatus = createReactQueryHook('getBrandOnboardingStatus', getBrandOnboardingStatus)
